import { ActiveFromActiveTo } from '@shared/models/active-from-active-to.model';
import { parseISO, isWithinInterval } from 'date-fns';

export const getDateRangeInMonths = (startDate: Date, endDate: Date): number => {
  const yearsDifference = endDate.getFullYear() - startDate.getFullYear();
  const monthsDifference = endDate.getMonth() - startDate.getMonth();

  const daysDifference = endDate.getDate() - startDate.getDate();
  const monthCorrection = daysDifference > 0 ? 1 : 0;

  return Math.max(0, yearsDifference * 12 + monthsDifference + monthCorrection);
};

export function isActiveEntity(entity: ActiveFromActiveTo, referenceDate: Date = new Date()): boolean {
  const start = parseISO(entity.activeFrom);
  const end = parseISO(entity.activeTo);

  return isWithinInterval(referenceDate, {
    start,
    end,
  });
}

export function subtractMonths(date: Date, monthsToSubtract: number): Date {
  const d = new Date(date);
  d.setMonth(d.getMonth() - monthsToSubtract);
  return d;
}
